import './bootstrap';
import jqueryConfirm from 'jquery-confirm';

// jquery-confirm (UMD) ở nhánh CommonJS chỉ export factory, không tự gắn vào jQuery (webpack trước đây đi nhánh AMD).
// public/js/cart.js dùng $.confirm/$.dialog.
jqueryConfirm(window, window.jQuery);

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

import('./commons');
import('./header');
import('./courses');
import('./galleries');
import('./comments');
import('./checkout');
import('./blogs');
import('./mycourse');
import('./action');
import('./booking');

import('./components/countdown');
import('./components/editor');

